import UserLanding from './UserLanding';

export default UserLanding;
